import { CORE, gateway } from '../../services/api';

export function prestarContasService(payload) {
  return gateway.post(`${CORE}/conta-corrente-usuario/prestar-conta`, payload);
}

export function calculoDsrService(idComissionado) {
  return gateway.get(`${CORE}/conta-corrente-usuario/calculo-dsr/${idComissionado}`);
}
